<template>
  <div>
    <md-app-toolbar>
      <div class="md-toolbar-row">
        <BuildingStockHeader />
      </div>
    </md-app-toolbar>
    <div class="page-container">
      <md-app md-mode="fixed">
        <md-app-content class="page-content">
          <div class="page-layout">
            <md-content>
              <md-table
                v-model="sitesData"
                class="sites-table"
                :md-sort.sync="currentSort"
                :md-sort-order.sync="currentSortOrder"
                :md-sort-fn="customSort"
                @md-selected="onSelectRow">
                <md-table-toolbar>
                  <h1 class="md-title">
                    Sites
                    <div class="md-caption">{{ resultsTotalCount }} sites</div>
                  </h1>
                </md-table-toolbar>

                <md-table-empty-state
                  md-label="Aucun résultat"
                  md-description="Aucun site trouvé pour cette recherche. Veuillez modifier vos critères." />

                <md-table-row
                  slot="md-table-row"
                  md-selectable="single"
                  slot-scope="{ item }">
                  <md-table-cell
                    md-label="Site"
                    md-sort-by="name">
                    <div>
                      <strong>{{ item.name }}</strong>
                    </div>
                    <div>
                      <em>{{ item.locality }}</em>
                    </div>
                  </md-table-cell>
                  <md-table-cell
                    md-label="ID.externe"
                    md-sort-by="extern_identifier">
                    {{ item.extern_identifier }}
                  </md-table-cell>
                  <md-table-cell
                    md-label="Fonction"
                    md-sort-by="function_id">
                    {{ item.function }}
                  </md-table-cell>
                  <md-table-cell
                    md-label="Surface utile (m²)"
                    md-sort-by="usable_area">
                    {{ item.usable_area|formatIntNumber }}
                  </md-table-cell>
                  <md-table-cell
                    md-label="Bâtiments"
                    md-sort-by="nb_buildings">
                    {{ item.nb_buildings }}
                  </md-table-cell>
                  <md-table-cell
                    md-sort-by="is_atypical"
                    md-label="Atypique">
                    {{ item.is_atypical|yesNoDisplay }}
                  </md-table-cell>
                  <md-table-cell
                    md-label="Conso totale (kWh)"
                    md-sort-by="energy_consumption">
                    {{ item.energy_consumption|formatIntNumber }}
                  </md-table-cell>
                  <md-table-cell
                    md-sort-by="exclusion_year"
                    md-label="Année d'exclusion">
                    {{ item.exclusion_year|valueIfNotNone }}
                  </md-table-cell>
                  <md-table-cell
                    md-sort-by="inclusion_year"
                    md-label="Année d'inclusion">
                    {{ item.inclusion_year|valueIfNotNone }}
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <div class="pagination">
                <div
                  v-if='sitesData.length > 0'>
                  <div>
                    <md-button
                      v-if="previousOffset != null"
                      @click='getPreviousPage()'
                      class="md-icon-button md-primary md-raised">
                      <md-icon>navigate_before</md-icon>
                    </md-button>
                  </div>
                  <div class="pagination__count">
                    {{ resultsFrom }} à {{ resultsTo }} sur {{ resultsCount }}
                  </div>

                  <div>
                    <md-button
                      v-if="nextOffset != null"
                      @click='getNextPage()'
                      class="md-icon-button md-primary md-raised">
                      <md-icon>navigate_next</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </md-content>
            <div class="filters__panel">
              <md-field>
                <label>Filtrer par nom de site</label>
                <md-input v-model="displayFilters.siteName" />
              </md-field>
              <div>
                <h3>
                  <md-checkbox
                    class="md-primary"
                    v-model="selectedAllFunctions">
                    Fonctions
                  </md-checkbox>
                </h3>
                <div
                  v-for="func in functionsList"
                  :key="func.id">
                  <md-checkbox
                    class="md-primary"
                    :value="func.id"
                    v-model="displayFilters.selectedFunctions">
                    {{ func.label }}
                  </md-checkbox>
                </div>
              </div>
              <div>
                <h3>
                  <md-checkbox
                    class="md-primary"
                    v-model="selectedAllStatus">
                    Statuts
                  </md-checkbox>
                </h3>
                <div
                  v-for="status in statusList"
                  :key="status.id">
                  <md-checkbox
                    class="md-primary"
                    :value="status.id"
                    v-model="displayFilters.selectedStatus">
                    {{ status.name }}
                  </md-checkbox>
                </div>
              </div>
              <div
                v-if='tagsList.length > 0'>
                <h3>Tags</h3>
                <div
                  v-for="tag in tagsList"
                  :key="tag.id">
                  <md-checkbox
                    class="md-primary"
                    :value="tag.id"
                    v-model="displayFilters.selectedTags">
                    {{ tag.name }}
                  </md-checkbox>
                </div>
              </div>
            </div>
          </div>
        </md-app-content>
      </md-app>
    </div>
  </div>
</template>

<script>
import session from '../api/session'
import axios from 'axios'
import BuildingStockHeader from '../components/BuildingStockHeader.vue'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'
var _ = require('lodash')

export default {
  name: 'BuildingStockSites',
  mixins: [ValuesDisplayMixin],
  components: { BuildingStockHeader },
  data () {
    return {
      functionsList: [],
      tagsList: [],
      apiLoaded: false,
      currentSort: 'name',
      currentSortOrder: 'desc',
      statusList: [
        {id: 1, name: 'Propriétaire occupant'},
        {id: 2, name: 'Propriétaire bailleur'},
        {id: 3, name: 'Locataire'},
        {id: 4, name: 'Copropriétaire'}
      ],
      sitesData: [],
      selectedAllFunctions: true,
      selectedAllStatus: true,
      displayFilters: {
        siteName: '',
        selectedFunctions: [],
        selectedTags: [],
        selectedStatus: [1, 2, 3, 4]
      },
      apiOffset: 0,
      resultsTotalCount: 0,
      resultsCount: 0,
      resultsFrom: 0,
      resultsTo: 0,
      previousOffset: null,
      nextOffset: null
    }
  },
  created: function () {
    // _.debounce est une fonction fournie par lodash pour limiter la fréquence
    // d'exécution d'une opération particulièrement couteuse.
    // Pour en savoir plus sur la fonction `_.debounce` (et sa cousine
    // `_.throttle`), visitez : https://lodash.com/docs#debounce
    this.debouncedGetSitesData = _.debounce(this.getSitesData, 1)
  },
  mounted: function () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Parc bâti')
    app.$store.dispatch('routing/update_return_kwargs', null)
    app.loadApi()
  },
  watch: {
    selectedAllFunctions: function (val) {
      var app = this
      app.displayFilters.selectedFunctions = []

      if (val === true) {
        for (var i in app.functionsList) {
          app.displayFilters.selectedFunctions.push(app.functionsList[i]['id'])
        }
      }
    },
    selectedAllStatus: function (val) {
      var app = this
      app.displayFilters.selectedStatus = []

      if (val === true) {
        app.displayFilters.selectedStatus = [1, 2, 3]
      }
    },
    displayFilters: {
      handler (val) {
        this.getSitesData(true)
      },
      deep: true
    }
  },
  methods: {
    getNextPage: function () {
      var app = this
      app.apiOffset = app.nextOffset
      app.getSitesData(false)
    },
    getPreviousPage: function () {
      var app = this
      app.apiOffset = app.previousOffset
      app.getSitesData(false)
    },
    getSitesData: function (resetPagination) {
      var app = this

      if (resetPagination === true) {
        app.apiOffset = 0
        app.resultsCount = 0
        app.resultsFrom = 0
        app.resultsTo = 0
        app.previousOffset = null
        app.nextOffset = null
      }

      if (app.apiLoaded === true) {
        // app.$store.dispatch('loading/begin_loading')

        var queryParams = {
          limit: 30,
          offset: app.apiOffset,
          sort_by: app.currentSort,
          sort_order: app.currentSortOrder
        }

        if (app.displayFilters.siteName.length > 0) {
          queryParams.name = app.displayFilters.siteName
        }

        if (app.displayFilters.selectedFunctions.length !== app.functionsList.length) {
          queryParams.functions = app.displayFilters.selectedFunctions
        }

        if (app.displayFilters.selectedStatus.length !== app.statusList.length) {
          queryParams.status = app.displayFilters.selectedStatus
        }

        if (app.displayFilters.selectedTags.length > 0) {
          queryParams.tags = app.displayFilters.selectedTags
        }

        session.get('/api/userdata/sites/', {params: queryParams}).then(function (sitesResponse) {
          app.sitesData = sitesResponse.data.results
          app.apiOffset = sitesResponse.data.offset
          app.resultsCount = sitesResponse.data.count
          app.resultsTotalCount = sitesResponse.data.total_count
          app.resultsFrom = sitesResponse.data.min
          app.resultsTo = sitesResponse.data.max
          app.previousOffset = sitesResponse.data.previous_offset
          app.nextOffset = sitesResponse.data.next_offset
        }).then(function (response) {
          // app.$store.dispatch('loading/end_loading')
        })
      }
    },
    loadApi () {
      var app = this

      app.$store.dispatch('loading/begin_loading')

      let functionsRequest = session.get('/api/parameters/functions/')
      let tagsRequest = session.get('/api/userdata/tags/')

      axios.all([functionsRequest, tagsRequest]).then(
        axios.spread(function (
          functionsResponse,
          tagsResponse
        ) {
          app.functionsList = functionsResponse.data
          app.functionsList.forEach(function (f) {
            app.displayFilters.selectedFunctions.push(f.id)
          })

          app.tagsList = tagsResponse.data
        })).then(function (response) {
        app.apiLoaded = true
        app.getSitesData(true)
        app.$store.dispatch('loading/end_loading')
      })
    },
    customSort (value) {
      var app = this
      app.getSitesData(true)
      return value
    },
    onSelectRow (item) {
      var app = this

      if (item.nb_buildings > 0) {
        app.$router.push({name: 'Building stock site', params: {siteId: item.id}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

.page-content {
  overflow: auto;
  height: calc(100vh - 64 * 2px);
}

.page-layout {
  display: flex;
  height: 100%;
}

.filters__panel {
  background-color: project-theme("background");
  padding: 0 20px;

  >>> .md-checkbox-label {
    white-space: nowrap;
  }
}

.main__panel {
  overflow: auto;
  flex-grow: 5;
  padding: 20px;
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 20px;
  }
}

.p-10 {
  padding: 20px 40px !important;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 100%;
    background: #86ad19;
    left: 0;
    top: 0;
  }
}

.pagination{
  padding: 10px;
  margin-top: 20px;
  border-top: 1px solid darken(white, 6);
  display: flex;
  justify-content: flex-end;

  >div{
    display: flex;
    align-items: center;
  }
  &__count{
    padding:.5rem 1rem;
  }
}
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/BuildingStockSites.vue